<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Asset Types</h1>
                <v-btn color="black" prepend-icon="mdi-plus" @click="duplicateFrom = null; createDialogSwitch = true">Add</v-btn>
            </v-col>
        </v-row>
        <h3></h3>
        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th></th>
                        <th v-if="user.type === 'admin'">Company</th>
                        <th-btn :sortedColumn="sortedColumn" column="name" sortable title="Name" @sort="sort"/>
                        <th>Category</th>
                        <th>Font Text</th>
                        <th>Font Color</th>
                        <th>Font Size</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="type in types" v-if="types.length" :key="type.id" class="text-left">
                        <td>
                            <v-avatar v-if="type.photo" :image="type.photo" rounded="sm" size="32"/>
                        </td>
                        <td v-if="user.type === 'admin'">{{ type.company_name }}</td>
                        <td>{{ type.name }}</td>
                        <td class="text-capitalize">{{ type.category }}</td>
                        <td>{{ type.font_text }}</td>
                        <td>{{ type.font_color }}</td>
                        <td>{{ type.font_size }}px</td>
                        <td class="text-capitalize">{{ type.status }}</td>
                        <td>
                            <v-btn-group v-if="user.type === 'admin' || type.company_id === user.company.id"
                                         density="compact" divided variant="outlined">
                                <v-btn :disabled="editDialogSwitch" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editType(type)">Edit
                                </v-btn>
                                <v-btn :disabled="createDialogSwitch" class="text-info" prepend-icon="mdi-content-copy"
                                       size="x-small" @click="duplicateType(type)">Duplicate
                                </v-btn>
                                <v-btn class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteType(type)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" colspan="7">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else colspan="7">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination v-model="currentPage" :length="totalPages" class="my-4" density="compact"
                                  @update:model-value="fetchTypes"></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Create v-if="createDialogSwitch" v-model="createDialogSwitch" :duplicateFrom="duplicateFrom" @addType="addType"/>
    <Edit v-if="editDialogSwitch" v-model="editDialogSwitch" :asset-type="selectedAssetType"
          @update-asset-type="updateType"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import ThBtn from "@/components/globals/th-btn.vue";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Edit from "@/components/dialogs/assets/types/Edit.vue";
import Create from "@/components/dialogs/assets/types/Create.vue";

const types = ref([]);
const {user} = useAuthStore();
const totalPages = ref(1);
const currentPage = ref(1);
const sortedType = ref(null);
const sortedColumn = ref(null);
const loading = ref(true);
const {showSnackbar} = useSnackbarStore();
const createDialogSwitch = ref(false);
const duplicateFrom = ref(null);
const selectedAssetType = ref(null);
const editDialogSwitch = ref(false);
const dialogSwitch = ref(false);

onMounted(() => {
    fetchTypes();
});

const fetchTypes = () => {
    let data = {
        page: currentPage.value,
        order: sortedType.value,
        sort: sortedColumn.value,
    };
    send('get', `asset-types`, data)
        .then((response) => {
            types.value = response.data.data.data;
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Types could not be loaded', 'error')
        })
}
const addType = (type) => {
    types.value.unshift(type);
}
const duplicateType = (type) => {
    duplicateFrom.value = type;
    createDialogSwitch.value = true;
}
const editType = (type) => {
    selectedAssetType.value = type;
    editDialogSwitch.value = true;
}
const updateType = (type) => {
    types.value.map((comp, index) => {
        if (comp.id === type.id) {
            types.value[index] = type;
        }
    });
}
const deleteType = (type) => {
    if (confirm(`Are you sure to delete "${type.name}" asset type?`)) {
        send('delete', `asset-types/${type.id}`)
            .then((response) => {
                if (response.data.success) {
                    types.value.map((item, index) => {
                        if (item.id === type.id) {
                            types.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${type.name}" Asset type could not be deleted`, 'error')
                }
            })
    }
}

const sort = (sorting) => {
    sortedColumn.value = sorting.column;
    sortedType.value = sorting.order;
    fetchTypes();
}
</script>

<style scoped>
</style>
